/* import __COLOCATED_TEMPLATE__ from './path-analysis-tab.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();